<div class="container" dir="rtl">
  <div *ngIf="report?.AirSystemScore" class="container">
    <ng-container *ngIf="report?.AirSystemScore !== -1">
      <div class="report-card">
        <p class="report-text text-center">{{report?.ProblemCategory}}</p>
        <div class="score-section py-4">
          <div class="score-number">
            <small>100 /</small>
            {{ report?.AirSystemScore }}
          </div>

          <div class="progress-track">
            <div class="progress-fill" [style.width.%]="report?.AirSystemScore"></div>
          </div>

          <div class="text-center pt-4">
            <span
              class="status-badge"
              [ngClass]="{
                'good': report?.AirSystemScore >= 70,
                'medium': report?.AirSystemScore >= 40 && report?.AirSystemScore < 70,
                'bad': report?.AirSystemScore < 40
                }">
              {{ report?.AirSystemLevel }}
            </span>
          </div>
        </div>

        <div class="report-section">
          <h3>گزارش تحلیل</h3>
          <div class="report-text">
            {{ report?.DiagnosticReport }}
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
